import {
  type ReactNode,
  createContext,
  useState
} from 'react'

interface Context {
  name?: string
  setName: (updatedName?: string) => void
}

interface ProviderProps {
  children: ReactNode
  name?: string
}

export const DocumentTitleContext = createContext<Context | undefined>(undefined)

export const DocumentTitleContextProvider = ({
  children,
  name: nameProp
}: ProviderProps) => {
  const [name, setName] = useState<string|undefined>(nameProp)

  const value = {
    name,
    setName
  }

  return (
    <DocumentTitleContext.Provider value={value}>
      {children}
    </DocumentTitleContext.Provider>
  )
}

interface ConsumerProps {
  children: (context: Context) => ReactNode
}

export const DocumentTitleContextConsumer = ({
  children: renderChildren
}: ConsumerProps) =>
  <DocumentTitleContext.Consumer>
    {
      (context?: Context) => {
        if (context === undefined) {
          throw new Error('<DocumentTitleContextConsumer /> must be used within <DocumentTitleContextProvider />')
        }

        return renderChildren(context)
      }
    }
  </DocumentTitleContext.Consumer>